module.exports = __webpack_public_path__ + "static/media/vaseCorrect.a0e5b306.png";